import { MatrixCell } from "./MatrixCell";
import { MatrixRow } from "./MatrixRow";

//declare var lastFocusCell: MatrixCell;

export class MatrixCommand {

    static insertColumnToLeft(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                var colIndex = lastFocusCell.colIndex;
                var matrixObject = lastFocusCell.row.matrixObject;
                for (var rowIdx = 0; rowIdx < matrixObject.rows.length; rowIdx++) {
                    var row = matrixObject.rows[rowIdx];

                    // insert copy of cell
                    var oldCell = row.cells[colIndex];
                    var newCell = new MatrixCell(oldCell.type, row);
                    newCell.rowSpan = oldCell.rowSpan;
                    // Copy style information to new cell.
                    newCell.width = oldCell.width;
                    //newCell.width = matrixObject.defaultWidth;
                    row.cells.splice(colIndex, 0, newCell);

                    if (newCell.isVisible()) {
                        // insert cell in screen table
                        var cellIndex = row.getCellIndex(colIndex);
                        var tr = <HTMLTableRowElement>matrixObject.control.rows[rowIdx];
                        var td = tr.insertCell(cellIndex);
                        newCell.createCell(td);
                    }
                    else if (oldCell.isInColSpan) {
                        oldCell.getLeftVisibleCell().colSpan++;
                    }
                }
                matrixObject.updateModelState();
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.insertColumnToLeft: " + err.message);
        }
    }

    static insertColumnToRight(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                var colIndex = lastFocusCell.colIndex;
                var matrixObject = lastFocusCell.row.matrixObject;
                for (var rowIdx = 0; rowIdx < matrixObject.rows.length; rowIdx++) {
                    var row = matrixObject.rows[rowIdx];

                    // insert copy of cell
                    var oldCell = row.cells[colIndex];
                    var newCell = new MatrixCell(oldCell.type, row);
                    newCell.rowSpan = oldCell.rowSpan;

                    // Copy style information to new cell.
                    newCell.width = oldCell.width;
                    //newCell.width = matrixObject.defaultWidth;
                    row.cells.splice(colIndex + 1, 0, newCell);

                    if (oldCell.colSpan > 1) {
                        newCell.type = 'h';
                        newCell.value = "";
                        oldCell.colSpan++;
                    }

                    if (newCell.isVisible()) {
                        // insert cell in screen table
                        var cellIndex = row.getCellIndex(colIndex);
                        var td = row.tr.insertCell(cellIndex + 1);
                        newCell.createCell(td);
                    }
                    else if (oldCell.isInColSpan) {
                        oldCell.getLeftVisibleCell().colSpan++;
                    }
                }
                matrixObject.updateModelState();
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.insertColumnToRight: " + err.message);
        }
    }

    static deleteColumn(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canDeleteColumn()) {
                    var colIndex = lastFocusCell.colIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;
                    for (var rowIdx = 0; rowIdx < matrixObject.rows.length; rowIdx++) {
                        var row = matrixObject.rows[rowIdx];

                        // get cell and remove it
                        var oldCell = row.cells[colIndex];

                        // visible cell index
                        var cellIndex = row.getCellIndex(colIndex);

                        // show next cell, if hidden
                        if (oldCell.isVisible() && oldCell.colSpan > 1) {
                            var nextCell = row.cells[colIndex + 1];
                            nextCell.type = oldCell.type;
                            nextCell.value = oldCell.value;
                            nextCell.colSpan = oldCell.colSpan - 1;

                            var td = <HTMLTableCellElement>row.tr.cells[cellIndex];
                            td.colSpan = nextCell.colSpan;
                            td.removeChild(oldCell.input);
                            nextCell.createCell(td);
                        }
                        else if (oldCell.isVisible()) {
                            if (oldCell.isField()) {
                                matrixObject.setFieldUsed(oldCell.value, false);
                                matrixObject.setFieldNameUsed(oldCell.value, false);
                            }
                            row.tr.deleteCell(cellIndex);
                        }
                        else if (oldCell.isInColSpan) {
                            oldCell.getLeftVisibleCell().colSpan--;
                        }

                        row.cells.splice(colIndex, 1);
                    }
                    matrixObject.updateModelState();

                    if (lastFocusCell.colIndex < lastFocusCell.row.cells.length)
                        lastFocusCell = lastFocusCell.row.cells[lastFocusCell.colIndex];
                    else if (lastFocusCell.colIndex > 0)
                        lastFocusCell = lastFocusCell.row.cells[lastFocusCell.colIndex - 1];
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.deleteColumn: " + err.message);
        }
    }

    static moveColumnToLeft(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canMoveColumnLeft()) {
                    var colIndex = lastFocusCell.colIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;
                    for (var rowIdx = 0; rowIdx < matrixObject.rows.length; rowIdx++) {
                        var row = matrixObject.rows[rowIdx];
                        var cell = row.cells[colIndex];

                        // visible cell index
                        var cellIndex = row.getCellIndex(colIndex);

                        if (cell.isVisible) {
                            row.tr.deleteCell(cellIndex);
                            var td = row.tr.insertCell(cellIndex - 1);
                            cell.createCell(td);
                        }

                        row.cells.splice(colIndex, 1);
                        row.cells.splice(colIndex - 1, 0, cell);
                    }
                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.moveColumnToLeft: " + err.message);
        }
    }

    static moveColumnToRight(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canMoveColumnRight()) {
                    var colIndex = lastFocusCell.colIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;
                    for (var rowIdx = 0; rowIdx < matrixObject.rows.length; rowIdx++) {
                        var row = matrixObject.rows[rowIdx];
                        var cell = row.cells[colIndex];

                        // visible cell index
                        var cellIndex = row.getCellIndex(colIndex);

                        if (cell.isVisible) {
                            row.tr.deleteCell(cellIndex);
                            var td = row.tr.insertCell(cellIndex + 1);
                            cell.createCell(td);
                        }

                        row.cells.splice(colIndex, 1);
                        row.cells.splice(colIndex + 1, 0, cell);
                    }
                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.moveColumnToRight: " + err.message);
        }
    }

    static increaseColumnWidth(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canIncreaseColumn()) {
                    var colIndex = lastFocusCell.colIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;
                    for (var rowIdx = 0; rowIdx < matrixObject.rows.length; rowIdx++) {
                        var row = matrixObject.rows[rowIdx];
                        var cell = row.cells[colIndex];
                        cell.width += 10;
                    }
                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.increaseColumnWidth: " + err.message);
        }
    }

    static decreaseColumnWidth(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canDecreaseColumn()) {
                    var colIndex = lastFocusCell.colIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;
                    for (var rowIdx = 0; rowIdx < matrixObject.rows.length; rowIdx++) {
                        var row = matrixObject.rows[rowIdx];
                        var cell = row.cells[colIndex];
                        cell.width -= 10;
                    }
                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.decreaseColumnWidth: " + err.message);
        }
    }

    static insertRowAbove(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canInsertRowAbove()) {
                    var colIndex = lastFocusCell.colIndex;
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    var row = new MatrixRow(matrixObject, rowIndex);

                    for (var i = 0; i < lastFocusCell.row.cells.length; i++) {
                        var cell = lastFocusCell.row.cells[i];
                        var newCell = new MatrixCell(cell.type, row);
                        newCell.rowSpan = 1;
                        newCell.colSpan = cell.colSpan;
                        newCell.width = cell.width;
                        newCell.value = "";
                        row.cells.push(newCell);
                    }
                    matrixObject.rows.splice(rowIndex, 0, row);

                    var tr = matrixObject.control.insertRow(rowIndex);
                    row.createRow(null, tr);

                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.insertRowAbove: " + err.message);
        }
    }

    static insertRowBelow(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canInsertRowBelow()) {
                    var colIndex = lastFocusCell.colIndex;
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    var row = new MatrixRow(matrixObject, rowIndex);

                    for (var i = 0; i < lastFocusCell.row.cells.length; i++) {
                        var cell = lastFocusCell.row.cells[i];
                        var newCell = new MatrixCell(cell.type, row);
                        newCell.rowSpan = 1;
                        newCell.colSpan = cell.colSpan;
                        newCell.width = cell.width;
                        newCell.value = "";
                        row.cells.push(newCell);
                    }
                    matrixObject.rows.splice(rowIndex + 1, 0, row);

                    var tr = matrixObject.control.insertRow(rowIndex + 1);
                    row.createRow(null, tr);

                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.insertRowBelow: " + err.message);
        }
    }

    static deleteRow(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canDeleteRow()) {
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    matrixObject.control.deleteRow(rowIndex);

                    matrixObject.rows.splice(rowIndex, 1);

                    matrixObject.updateModelState();
                }

                if (lastFocusCell.rowIndex < matrixObject.rows.length)
                    lastFocusCell = matrixObject.rows[lastFocusCell.rowIndex].cells[lastFocusCell.colIndex];
                else if (lastFocusCell.rowIndex > 0)
                    lastFocusCell = matrixObject.rows[lastFocusCell.rowIndex - 1].cells[lastFocusCell.colIndex];
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.deleteRow: " + err.message);
        }
    }

    static moveRowUp(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canMoveRowUp()) {
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    // save values
                    var row = lastFocusCell.row;
                    row.saveValues();

                    matrixObject.control.deleteRow(rowIndex);
                    var tr = matrixObject.control.insertRow(rowIndex - 1);
                    row.createRow(null, tr);

                    matrixObject.rows.splice(rowIndex, 1);
                    matrixObject.rows.splice(rowIndex - 1, 0, row);

                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.moveRowUp: " + err.message);
        }
    }

    static moveRowDown(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canMoveRowDown()) {
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    // save values
                    var row = lastFocusCell.row;
                    row.saveValues();

                    matrixObject.control.deleteRow(rowIndex);
                    var tr = matrixObject.control.insertRow(rowIndex + 1);
                    row.createRow(null, tr);

                    matrixObject.rows.splice(rowIndex, 1);
                    matrixObject.rows.splice(rowIndex + 1, 0, row);

                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.moveRowDown: " + err.message);
        }
    }

    static mergeCellRight(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canMergeRight()) {
                    var colIndex = lastFocusCell.colIndex;
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    for (var i = 0; i < lastFocusCell.rowSpan; i++) {
                        var row = matrixObject.rows[rowIndex + i];
                        var cell = row.cells[colIndex];
                        var nextCell = row.cells[colIndex + cell.colSpan];

                        if (nextCell.isVisible() && (colIndex + cell.colSpan)) {
                            var cellIndex = row.getCellIndex(nextCell.colIndex);
                            row.tr.deleteCell(cellIndex);
                            console.log(`addin width: cell: ${cell.width} + nextCell: ${nextCell.width}`);
                            // Mind for Maestro 4 conversion
                            cell.width = cell.width + nextCell.width;
                        }

                        cell.colSpan += nextCell.colSpan;
                        nextCell.type = "h";
                        nextCell.value = "";
                        nextCell.colSpan = 1;
                    }
                    matrixObject.updateModelState();
                } else {
                    alert(Resources._TabMatrixPartial.errCantMergeCells);
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.mergeCellRight: " + err.message);
        }
    }

    static splitCellRight(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canSplitRight()) {
                    var colIndex = lastFocusCell.colIndex;
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    for (var i = 0; i < lastFocusCell.rowSpan; i++) {
                        var row = matrixObject.rows[rowIndex + i];
                        var cell = row.cells[colIndex];
                        var nextCell = row.cells[colIndex + cell.colSpan - 1];
                        cell.colSpan--;
                        // Mind for Maestro 4 conversion
                        cell.width = cell.width - nextCell.width;
                        nextCell.type = "t";
                        nextCell.value = "";
                        nextCell.colSpan = 1;
                        nextCell.rowSpan = cell.rowSpan;

                        var cellIndex = row.getCellIndex(nextCell.colIndex);
                        var td = row.tr.insertCell(cellIndex);
                        nextCell.createCell(td);
                    }
                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.mergeCellRight: " + err.message);
        }
    }

    static mergeCellDown(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canMergeDown()) {
                    var colIndex = lastFocusCell.colIndex;
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    var nextCell = matrixObject.rows[rowIndex + lastFocusCell.rowSpan].cells[colIndex];

                    var cellIndex = nextCell.row.getCellIndex(nextCell.colIndex);

                    lastFocusCell.rowSpan += nextCell.rowSpan;
                    nextCell.type = "h";
                    nextCell.value = "";
                    nextCell.rowSpan = 1;

                    nextCell.row.tr.deleteCell(cellIndex);

                    matrixObject.updateModelState();
                } else {
                    alert(Resources._TabMatrixPartial.errCantMergeCells);
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.mergeCellDown: " + err.message);
        }
    }

    static splitCellDown(lastFocusCell: MatrixCell): void {
        try {
            if (lastFocusCell) {
                if (lastFocusCell.canSplitDown()) {
                    var colIndex = lastFocusCell.colIndex;
                    var rowIndex = lastFocusCell.rowIndex;
                    var matrixObject = lastFocusCell.row.matrixObject;

                    var nextCell = matrixObject.rows[rowIndex + lastFocusCell.rowSpan - 1].cells[colIndex];
                    nextCell.type = lastFocusCell.type;
                    nextCell.value = "";
                    nextCell.colSpan = lastFocusCell.colSpan;
                    nextCell.rowSpan = 1;

                    var cellIndex = nextCell.row.getCellIndex(nextCell.colIndex);

                    lastFocusCell.rowSpan--;

                    var td = nextCell.row.tr.insertCell(cellIndex);
                    nextCell.createCell(td);

                    matrixObject.updateModelState();
                }
                lastFocusCell.focus();
            }
        }
        catch (err) {
            alert("MatrixCommand.splitCellDown: " + err.message);
        }
    }

    static textToField(lastFocusCell: MatrixCell): void {
        if (lastFocusCell) {
            lastFocusCell.textToField();
            lastFocusCell.row.matrixObject.updateModelState();
            lastFocusCell.focus();
        }
    }

    static fieldToText(lastFocusCell: MatrixCell): void {
        if (lastFocusCell) {
            lastFocusCell.fieldToText();
            lastFocusCell.row.matrixObject.updateModelState();
            lastFocusCell.focus();
        }
    }

    // field select popup: click on field
    static onFieldNameSelect = (id: string, lastFocusCell: MatrixCell): void => {
        $('#masterScreenMask').css("display", "none");
        //$("#matrix-field-select").hide();
        lastFocusCell.newFieldName(id);
        lastFocusCell.row.matrixObject.updateModelState();
        lastFocusCell.focus();
    }

    // field select popup: click on field
    static onFieldSelect = (id: string, lastFocusCell: MatrixCell): void => {
        lastFocusCell.newField(id);
        lastFocusCell.row.matrixObject.updateModelState();
        lastFocusCell.focus();
    }

    // field select popup: cancel
    static onButtonCancelClick(lastFocusCell: MatrixCell): void {
        $('#masterScreenMask').css("display", "none");
        $("#matrix-field-select").hide();
        lastFocusCell.focus();
    }

    // field select popup: empty
    static onButtonEmptyClick(lastFocusCell: MatrixCell): void {
        $('#masterScreenMask').css("display", "none");
        $("#matrix-field-select").hide();
        lastFocusCell.fieldEmpty();
        lastFocusCell.row.matrixObject.updateModelState();
        lastFocusCell.focus();
    }

}